.pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px !important;
  background-color: var(--dark-6);
  border: 1px solid var(--dark-4);
  border-radius: 6px;
}

.swatch {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 4px;
  flex-shrink: 0;
}

.hexText {
  font-family: 'Roboto Mono', monospace;
  font-weight: 500;
  font-size: inherit;
  line-height: 1;
}
